var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AboutWhisky-A-Header'),_c('AboutWhisky-B-Origins'),_c('AboutWhisky-C-World'),_c('AboutWhisky-D-Blog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }